var source = require('./source');

var sink = require('./sink');

module.exports = function (socket, options) {
  options = options || {};

  if (options.binaryType) {
    socket.binaryType = options.binaryType;
  } else if (options.binary) {
    socket.binaryType = 'arraybuffer';
  }

  var duplex = {
    sink: sink(socket, options),
    source: source(socket, options),
    connected: function connected() {
      return duplex.source.connected();
    }
  };
  return duplex;
};